module.exports = __webpack_public_path__ + "img/step11.70c678b3.png";